import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { canPublish, useEditorialMe } from './me'

/** An editors' screen (Schedule, Social, Topic pages, Settings): a writer who follows a link here
 *  lands on the Desk. The server refuses their actions either way. */
export function EditorOnly({ children }: { children: ReactNode }) {
  const me = useEditorialMe()
  if (me.isPending) return null
  if (!canPublish(me.data)) return <Navigate to=".." relative="path" replace />
  return <>{children}</>
}
